import {dataTestId} from '@hconnect/uikit'
import {Box} from '@mui/material'
import React from 'react'

const LINE_WIDTH_PX = 2

export interface CurrentTimeIndicatorProps {
  xOffset: number
  color: string
}

export const CurrentTimeIndicator: React.FC<CurrentTimeIndicatorProps> = ({xOffset, color}) => {
  // no need to display it outside of the viewport
  if (xOffset < 0) return null
  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: Math.round(xOffset - LINE_WIDTH_PX / 2),
        height: 1,
        width: LINE_WIDTH_PX,
        backgroundColor: color,
        pointerEvents: 'none',
        zIndex: 1
      }}
      {...dataTestId('current_time_indicator')}
    />
  )
}
